import { Avatar, AvatarSize } from '@eventbrite/eds-avatar';
import React from 'react';
import { OrganizerContext, UseTrustSignalsContext } from '../../context';
import { Organizer } from '../../types';
import { getOrganizerProfileAAExperiment } from '../../utils/statsig';
import { OrganizerTrustSignals } from '../OrganizerTrustSignals';
import './Header.scss';
import { OrganizerDetails } from './OrganizerDetails';

export interface HeaderProps {
    organizer: Organizer;
    website: string;
    hasPermissionToEditOrganizationInfo: boolean;
    userId: string;
}

const Title: React.FunctionComponent = (props) => {
    return (
        <h1
            className={'organizer-profile-new-layout-header__title eds-text-hs'}
        >
            {props.children}
        </h1>
    );
};

const ProfileImage: React.FunctionComponent<{ src: string }> = (props) => {
    const { src } = props;

    if (!src) {
        return null;
    }

    return (
        <div className="organizer-profile-new-layout-header__profile-image">
            <Avatar imageUrl={src} size={AvatarSize.medium} />
        </div>
    );
};

export const Header: React.FunctionComponent<HeaderProps> = (props) => {
    const organizer = React.useContext(OrganizerContext) as Organizer;
    const trustSignalsContext = UseTrustSignalsContext();
    const followers = trustSignalsContext?.followers || 0;
    const pastEvents = organizer?.num_past_events || 0;
    const futureEvents = organizer?.num_future_events || 0;

    const totalEventsCount = pastEvents + futureEvents;
    const userId = props.userId;

    const hasDescription =
        !!organizer.description &&
        organizer.description.text &&
        organizer.description.text.trim() !== '';
    const hasSocialLinks =
        !!organizer.website || !!organizer.twitter || !!organizer.facebook;

    getOrganizerProfileAAExperiment();

    return (
        <header className="organizer-profile-new-layout-header" id="about">
            <div
                className={`organizer-profile-new-layout-header__responsive-container ${
                    !hasDescription && !hasSocialLinks
                        ? 'organizer-profile-new-layout-header__responsive-container--no-content'
                        : ''
                }`}
            >
                <div className="organizer-profile-new-layout-header__content-container">
                    <div
                        className={`organizer-profile-new-layout-header__main-content ${
                            !props.organizer?.logo?.url
                                ? 'organizer-profile-new-layout-header__main-content--no-avatar'
                                : ''
                        }`}
                    >
                        <div className="organizer-profile-new-layout-header__avatar-container">
                            <ProfileImage src={props.organizer?.logo?.url} />
                        </div>
                        <div className="organizer-profile-new-layout-header__organizer-info">
                            <Title>{props.organizer.name}</Title>
                            <OrganizerTrustSignals
                                organizer={organizer}
                                followCount={followers}
                                totalEvents={totalEventsCount}
                            />
                        </div>
                    </div>
                </div>
                <div className="organizer-profile-new-layout-header__buttons">
                    <OrganizerDetails
                        totalEvents={totalEventsCount}
                        organizer={organizer}
                        userId={userId}
                    />
                </div>
            </div>
        </header>
    );
};
